export interface AccessibilitySettings {
  fontSize: 100 | 115 | 130 | 150;
  highContrast: boolean;
  wideLineSpacing: boolean;
  highlightLinks: boolean;
  easyReading: boolean;
}

export const DEFAULT_ACCESSIBILITY_SETTINGS: AccessibilitySettings = {
  fontSize: 100,
  highContrast: false,
  wideLineSpacing: false,
  highlightLinks: false,
  easyReading: false,
};
